import { BRAND_NAME, BrandIcon, BrandLogo } from '@/design-system';

export interface RailBrandProps {
    /**
     * Uitgeklapt - de vaste rail en de schuiflade - staat het woordmerk er.
     * Ingeklapt - de rail zit achter "Menu" in de smalle balk - alleen het
     * beeldmerk.
     */
    collapsed?: boolean;
    className?: string;
}

/**
 * Het merk in de navigatie: het Smartkeur-logo op de donkere ondergrond van de
 * rail, met "Smart" in wit en het beeldmerk en "keur" in merkgroen.
 *
 * Het woordmerk is 20px hoog: even hoog als het vierkantje uit het prototype en
 * met letters zo groot als de naam die ernaast stond, zodat de rail er niet van
 * verschuift. Zie `docs/design/brand.md`.
 */
export function RailBrand({ collapsed = false, className }: RailBrandProps) {
    return collapsed ? (
        <BrandIcon size={22} title={BRAND_NAME} className={className} />
    ) : (
        <BrandLogo surface="dark" height={20} className={className} />
    );
}
